// extracted by mini-css-extract-plugin
export default {"link":"basket-link--13291","link__tn":"basket-link__tn--e1e2c"};